import React from 'react';
import { ComponentManager } from '@adp-wfn/mdf-core';
import classNames from 'classnames';
import vdlPrefix from '../util/vdlPrefix';
import CaretIcon from 'adp-react-icons/lib/fa/caret-left';
import { omit } from 'lodash';

export interface ISidebarItemProps {
  // Is this item active.
  active?: boolean;
  // A CSS class name for overriding styles.
  className?: string;
  // The view to load when this item is selected.
  customItem?: string;
  // The icon to display in the sidebar item.
  icon?: React.ReactNode;
  // The id to appear in the HTML list item element (<li></li>)
  id?: string;
  // The label to use in the sidebar item.
  label?: React.ReactNode;
  // Called when a user selects this item.
  onSelect: () => void;
}

// This array exists to make it possible to use lodash functions to filter properties.
// It's not possible to extract keys from a TypeScript interface, but we can make sure
// the array contains all the necessary keys.
const customSidebarItemPropsKeys = [
  'active',
  'className',
  'customItem',
  'icon',
  'id',
  'label',
  'onSelect'
];

export class MDFCustomSidebarItem extends React.Component<ISidebarItemProps, {} > {
  render() {
    const { active } = this.props;
    const sidebarItemClasses = {
      [vdlPrefix('sidebar-item')]: true,
      [vdlPrefix('sidebar-item--active')]: active
    };

    const customProps = omit(this.props, customSidebarItemPropsKeys);
    const CustomView = ComponentManager.getComponent(this.props.customItem);

    return (
      <li {...customProps} className={classNames(sidebarItemClasses)}>
        <CustomView />
        {active && <CaretIcon className={vdlPrefix('sidebar-item__active-indicator')}/> }
      </li>
    );
  }
}
